import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { CONSTANTS } from '../../constants/Constants';
const formatUrl = (props, isSameModule, isExternal) => {
  const {
    modules,
    card
  } = props;
  let url = card.path;
  if (modules && modules.length > 0) {
    if (!isSameModule && !isExternal) {
      url = "".concat(window.location.origin).concat(card.path);
    }
  }
  return url;
};
const checkSameModule = (modules, path) => modules.some(module => {
  if (module === '/') {
    return CONSTANTS.OTHER_MODULES.every(modulePath => path.indexOf(modulePath) !== 0);
  }
  return path.indexOf(module) === 0;
});
const NavigationCard = props => {
  const {
    label,
    card,
    modules
  } = props;
  const {
    is_external: isExternal
  } = card;
  const isSameModule = !isExternal ? checkSameModule(modules, card.path) : false;
  const linkStyle = {
    borderBottomColor: card.groupColor
  };
  const innerContent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "card-innerTxt"
  }, label), /*#__PURE__*/React.createElement("span", {
    className: "card-txt",
    title: card.label
  }, card.label));
  const handleClick = e => {
    if (e.metaKey || e.ctrlKey) {
      e.stopPropagation();
      return;
    }
    if (!isSameModule) {
      e.preventDefault();
    }
  };
  return /*#__PURE__*/React.createElement(Fragment, null, isSameModule ? /*#__PURE__*/React.createElement(Link, {
    to: card.path,
    className: "card-link",
    style: linkStyle,
    onClick: handleClick
  }, innerContent) : /*#__PURE__*/React.createElement("a", {
    href: formatUrl(props, isSameModule, isExternal),
    className: "card-link",
    style: linkStyle,
    onClick: handleClick
  }, innerContent));
};
NavigationCard.propTypes = {
  label: PropTypes.string.isRequired,
  modules: PropTypes.arrayOf(PropTypes.oneOf(['/', ...CONSTANTS.OTHER_MODULES])).isRequired,
  card: PropTypes.object.isRequired,
  inlineCollapsed: PropTypes.bool
};
export default NavigationCard;